import styled from "styled-components";

import {
    LockOpen as LockOpenIcon,
    LocalOfferOutlined as LocalOfferOutlinedIcon
} from '@mui/icons-material';

export const TokenContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  background-color: #FFFFFF;
  border: 1px solid #0B4598;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    border-color: #08336d;
    background-color: #f8f9fa;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.07);
  }
  
  &:last-child {
    margin-bottom: 0;
  }
`

export const StyledLockOpenIcon = styled(LockOpenIcon)`
  width: 48px !important;
  height: 48px !important;
  margin-right: 1.5rem;
  color: #0B4598;
`

export const StyledLocalOfferOutlinedIcon = styled(LocalOfferOutlinedIcon)`
  width: 15px !important;
  height: 15px !important;
  margin-right: 0.5rem;
`

export const TokenTitle = styled.div`
  font-size: 1.15rem;
  line-height: 1.2;
  font-weight: 600;
  color: #0B4598;
  margin-bottom: 0.35rem;
`

export const TokenDescription = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
`

export const TokenPrice = styled.div`
  color: #333333;
  font-size: 0.9rem;
  font-weight: 500;
`

export const TokenDiscount = styled.div`
  display: flex;
  align-items: center;
  background-color: #0B4598;
  border-radius: 4px;
  padding: 0.2rem 0.6rem;
  color: white;
  font-size: 0.7rem;
  font-weight: 500;
  text-transform: uppercase;
`

export const InfoLink = styled.a`
  display: block;
  margin-top: 1.5rem;
  font-size: 0.85rem;
  color: #0B4598;
  text-decoration: none;
  font-weight: 500;

  &:hover {
  text-decoration: underline;
  }
`
